import ErrorPage from "./pages/page404";
import Home from "./pages/home";
import About from "./pages/about";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Contact from "./pages/contact";
import Insight from "./pages/Insight";
import "sweetalert2/src/sweetalert2.scss";
import DonorInfoRequest from "./pages/donorInfo";
import MoveUp from "./components/MoveUp";
import ResetPassword from "./pages/forgot-password/ResetPassword";
import Dashboard from "./layouts/Dashboard";
import { Main } from "./layouts/Main";
import Privacy from "./pages/privacy";
import UserBoard from "./pages/user";
import DashboardEdit from "./pages/user/dashboardEdit/DashboardEdit";
import Need from "./pages/needBlood";
import AuthGuard from "./guard/AuthGuard";
import Verified from "./pages/auth/Verified";

function App() {
  return (
    <Router>
      <div>
        <Routes>
          <Route element={<Dashboard />}>
            <Route path="dashboard" element={<UserBoard />} />
            <Route path="auth" element={<AuthGuard />} />
            <Route path="reset-password/:token" element={<ResetPassword />} />
            <Route exact path="verify/email/:id/*" element={<Verified />} />
            {/* <Route
              exact
              path="auth/verify/email/:id/*"
              element={<Verified />}
            /> */}
          </Route>

          <Route path="/" element={<Main />}>
            <Route index element={<Home />} />
            <Route path="home" element={<Home />} />
            <Route path="need-blood" element={<Need />} />
            <Route path="about-us" element={<About />} />
            <Route path="donor-request/:id" element={<DonorInfoRequest />} />
            <Route path="edit" element={<DashboardEdit />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="contact-us" element={<Contact />} />
            <Route path="insights" element={<Insight />} />
            <Route path="*" element={<ErrorPage />} />
          </Route>
        </Routes>
        <MoveUp />
      </div>
    </Router>
  );
}

export default App;
